/**
 * React Query keys for data shared across screens.
 *
 * A key must always hold the same shape wherever it is used: two screens
 * caching different shapes under one key (for example the raw API envelope
 * on one screen and the unwrapped array on another) crash whichever screen
 * reads the other's data from the cache.
 */
export const queryKeys = {
  teams: ['teams'] as const,
  offices: ['offices'] as const,
  /** Prefix of the paginated department list, ['department', page, ...]. */
  departments: ['department'] as const,
  /** The signed-in user's profile, GET /v1/profile. */
  currentUserProfile: ['current-user-profile'] as const,
};
